import { combineReducers } from "redux";

import fbdataReducer from "./fbdata/fbdata.reducer";
import cartReducer from "./salepage/cartReducer";
import orders from "./setOrder/orders";
import patchBack from "./setPatch/patchBack";
import {
  setNotiOrders,
} from "./notiorder/getNotiorder";

const rootReducer = combineReducers({
  fbdata: fbdataReducer,
  salepage: cartReducer,
  setorder: orders,
  notiorder: setNotiOrders,
  setpatch: patchBack,
});


export default rootReducer;
